/**
 * Uygulama genelinde kullanılan filtre parametreleri sabitleri
 * Bu bileşenler arası tutarlılığı sağlar
 */

// Filtre parametre isimleri
export const FILTER_PARAMS = {
    // Temel araç bilgileri
    BRAND: 'brand',
    MODEL: 'model',
    BODY_TYPE: 'bodyType',

    // Fiyat aralığı
    MIN_PRICE: 'minPrice',
    MAX_PRICE: 'maxPrice',

    // Yıl aralığı
    MIN_YEAR: 'minYear',
    MAX_YEAR: 'maxYear',

    // Araç detayları
    FUEL_TYPE: 'fuelType',
    TRANSMISSION: 'transmission',

    // Kilometre aralığı
    MIN_KM: 'minKm',
    MAX_KM: 'maxKm'
};

// Boş filtre durumu - bileşenler arasında kullanılabilir
export const DEFAULT_FILTER_STATE = {
    [FILTER_PARAMS.BRAND]: '',
    [FILTER_PARAMS.MODEL]: '',
    [FILTER_PARAMS.BODY_TYPE]: '',
    [FILTER_PARAMS.MIN_PRICE]: '',
    [FILTER_PARAMS.MAX_PRICE]: '',
    [FILTER_PARAMS.MIN_YEAR]: '',
    [FILTER_PARAMS.MAX_YEAR]: '',
    [FILTER_PARAMS.FUEL_TYPE]: '',
    [FILTER_PARAMS.TRANSMISSION]: '',
    [FILTER_PARAMS.MIN_KM]: '',
    [FILTER_PARAMS.MAX_KM]: ''
};